import { useEffect } from 'react';

import SimplifiedSignup from '@/components/SimplifiedSignup';
import messages from '@/components/SimplifiedSignup/configs/SubscriptionExtension/messages';
import { useSimplifiedSignupContext } from '@/components/SimplifiedSignup/Context';
import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { useUserState } from '@/hooks/store';
import { useComponentDidMount } from '@/hooks/utils/useComponentDidMount';
import { User } from '@/store/user/types';

import { cannotExtendSubscription } from './util';

const isNotEligibleUser = (user: User | null, activeScreenKey: string) => {
	return !!user && activeScreenKey === 'account' && cannotExtendSubscription(user);
};

const SubscriptionExtension = () => {
	const { setAuthPrompt } = useAuthPrompt();
	const user = useUserState();
	const { activeScreenKey, setError } = useSimplifiedSignupContext();

	useComponentDidMount(() => {
		setAuthPrompt('login');
	});

	useEffect(() => {
		if (isNotEligibleUser(user, activeScreenKey)) {
			setError({
				onScreenViewed: logEvent => {
					logEvent({
						eventName: 'Screen : Viewed',
						eventProps: {
							screen: 'Ineligible',
						},
					});
				},
				heading: messages.ineligibleErrorHeading,
				subheading: messages.ineligibleErrorSubheading,
				cta: {
					label: messages.ineligibleErrorCta,
					onClick: async (routerPush, logEvent) => {
						logEvent({
							eventName: 'Subscribe : Purchase : Form : Ineligible CTA : Clicked',
							eventProps: {
								CTA: messages.ineligibleErrorCta.defaultMessage,
							},
						});
						await routerPush('/app');
					},
				},
			});
		}
	}, [activeScreenKey, setError, user]);

	return <SimplifiedSignup />;
};

export default SubscriptionExtension;

export { getServerSideProps } from '@/utils/pageGeneration/getServerSideProps';
